import { RefreshCw, AlertCircle } from "lucide-react";

export function ErrorView({ product, onRetry }) {
  return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center">
      <div className="w-20 h-20 rounded-full bg-[#fee2e2] flex items-center justify-center mx-auto">
        <AlertCircle size={38} className="text-[#b91c1c]" />
      </div>
      <h1 className="mt-6 font-display text-2xl font-bold text-[#9c5f27]">Algo deu errado na geração</h1>
      <p className="mt-3 text-[#5c4634]">{product.error_message}</p>
      <button
        onClick={onRetry}
        className="btn-orange mt-6 px-6 py-3 rounded-full font-semibold inline-flex items-center gap-2"
        data-testid="retry-generation-btn"
      >
        <RefreshCw size={18} /> Tentar de novo
      </button>
    </div>
  );
}
